// Domain
import { PauseTrackingReasonEntity } from '../entities/pause-tracking-reason-entity';

export default class PauseTrackingReasonsState {
  loaded = false;

  items: Array<PauseTrackingReasonEntity> = [];
}
